
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fleet-management",
      function () {
        return require("private-next-pages/fleet-management.js");
      }
    ]);
  